import { useEffect, useRef } from 'react';
import { consumeAthkarLaunch, listenAthkarLaunch, listenAthkarTaps } from '../utils/athkarLaunch';

/**
 * يفتح الأذكار حين يُضغط إشعارها.
 *
 * يسأل عند التركيب وعند كل عودة للواجهة: الضغط والتطبيق في الخلفية
 * لا يعيد تركيب الصفحة، بل يُظهرها فقط.
 */
export function useAthkarLaunch(onOpen) {
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    const consume = () => consumeAthkarLaunch().then((c) => c && onOpenRef.current(c));
    const check = () => {
      if (document.visibilityState !== 'visible') return;
      consume();
    };

    check();
    document.addEventListener('visibilitychange', check);
    const stop = listenAthkarTaps((c) => onOpenRef.current(c));
    // التطبيق أمامي: onNewIntent يرسل إشارة بدل visibilitychange، فلا حارس رؤية هنا.
    const stopSignal = listenAthkarLaunch(consume);

    return () => {
      document.removeEventListener('visibilitychange', check);
      stop();
      stopSignal();
    };
  }, []);
}
